$(document).ready(function(){
	init(); 
	$(window).trigger('resize');
	$(window).trigger('scroll');	
});

function init(){
	// Get the gclid parameter from the url
	getGclidParameter();

	// Append gclid to links on the same domain that open in a new tab
	appendLinksWithGclid();

	// Append Radisson links with gclid
	appendRadissonLinksWithGclid();

	//Lazyload Images
	$(window).on('load scroll resize', function() {
		$('.js__lazyload:visible').each(function() {
			if ( isVisible($(this)) ) {
				if ( $(this).data('srcset') ) {
					$(this).attr('srcset', $(this).data('srcset'));
					$(this).removeAttr('data-srcset');
				}

				if ( $(this).data('src') ) {
					$(this).attr('src', $(this).data('src'));
					$(this).removeAttr('data-src');
				}	

				if ( $(this).data('bg-image') ) {
					var imageUrl = $(this).data('bg-image');
					$(this).css('background-image', 'url(' + imageUrl + ')');
					$(this).removeAttr('bg-image');
				}	
			}
		});	
	});

	function isVisible(elem) {
		var scrollTop = $(window).scrollTop();
		var windowBottom = scrollTop + $(window).height();
		var offset = 100;
		var elementTop = elem.offset().top;

		if ( (windowBottom + offset) > elementTop ) {
			return true;
		} else {
			return false;
		}
	}
	
	//Sticky nav on scroll
	$(window).on('scroll resize', function() {
		var scrollElem;

		if ( $('.m__check-availability').length ) {
			scrollElem = $('.m__check-availability');
		} else if ( $('.m__full-width-video').length ) {
			scrollElem = $('.m__full-width-video');
		} else {
			scrollElem = $('.m__full-width-image.module-1');
		}

		var scrollTop = $(window).scrollTop();
		var elemBottom = scrollElem.offset().top + scrollElem.outerHeight();

		if ( scrollTop >= elemBottom ) {
			$('.m__header').addClass('scrolled');
		} else {
			$('.m__header').removeClass('scrolled');
		}
	});

	// Header Scripts
	$('.menu-toggle').click(function(e) {
		e.preventDefault();

		if ( !$(this).hasClass('open') ) { // hamburger showing
			$(this).addClass('open');
			$('.main-menu-overlay').addClass('active');
			$('html, body, div#container').addClass('no-scroll');
			$('header').addClass('fixed');
			$('.header-small-nav-section .nav').addClass('hide-nav');
		} else { // Close icon showing

			if ( !$('.reservations-overlay').hasClass('active') ) { // reservations overlay not active
				$('.main-menu-overlay').removeClass('active');
				$(this).removeClass('open');
				$('html, body, div#container').removeClass('no-scroll');
				$('header').removeClass('fixed');
				$('.header-small-nav-section .nav').removeClass('hide-nav');
			} else { // reservations overlay is active
				if ( $('.main-menu-overlay').hasClass('active') ) { // if main menu overlay is also active
					$('.reservations-overlay').removeClass('active'); // only hide reservations overlay to show main menu
					$('header').removeClass('reservations-active');
				} else { // main menu overlay isn't active but reservation is
					$('.reservations-overlay').removeClass('active');
					$('header').removeClass('reservations-active');
					$('.menu-toggle').removeClass('open');
					$('html, body, div#container').removeClass('no-scroll');
					$('header').removeClass('fixed');
					$('.header-small-nav-section .nav').removeClass('hide-nav');
				}
			}
		}
	});

	$('.reservations-toggle').click(function(e) {
		e.preventDefault();
		
		if ( !$('.reservations-overlay').hasClass('active') && !$('.main-menu-overlay').hasClass('active') ) {
			// Nothings open
			$('.reservations-overlay').addClass('active');
			$('header').addClass('reservations-active');
			$('.menu-toggle').addClass('open');
			$('html').addClass('no-scroll');
			$('.header-small-nav-section .nav').addClass('hide-nav');
		} else if ( !$('.reservations-overlay').hasClass('active') && $('.main-menu-overlay').hasClass('active') ) {
			// Main Menu overlay is active and Reservations overlay isn't
			$('.reservations-overlay').addClass('active');
			$('header').addClass('reservations-active');
		} else if ( $('.reservations-overlay').hasClass('active') && !$('.main-menu-overlay').hasClass('active') ) {
			// Reservations overlay is active and Main Menu overlay isn't
			$('.reservations-overlay').removeClass('active');
			$('header').removeClass('reservations-active');
			$('.menu-toggle').removeClass('open');
			$('html').removeClass('no-scroll');
			$('.header-small-nav-section .nav').removeClass('hide-nav');
		} else if ( $('.reservations-overlay').hasClass('active') && $('.main-menu-overlay').hasClass('active') ) {
			// Both Reservations and Main Menu overlays are active
			$('.reservations-overlay').removeClass('active');
			$('header').removeClass('reservations-active');
		}
	});

	// Check Availability
	$('select#rateSearch').on('change', function(e) {
		var form = $(this).closest('form');
		var selected = $(this).find(':selected');
		var codeType = selected.data('code-type');

		if ( codeType != '' ) {
			form.find('input#code').attr('name', codeType);
		} else {
			form.find('input#code').removeAttr('name');
		}
	});

	//Add another room
	$('.js__additional-add-rooms-trigger').on('click', function (e) {
		e.preventDefault();

		var parentElem = $(this).closest('.guests-container');
		var container = parentElem.find('.rooms-popup');
		var numRoomsElem = container.find('.room-counter__counter p');
		var numRooms = parseInt(numRoomsElem.html()) + 1;

		if (numRooms <= 9) {
			// Update the rooms data attribute
			parentElem.find('.js__book-num-rooms').attr('data-rooms', numRooms);

			// Update the popup rooms number indicator
			numRoomsElem.html(numRooms);

			// Show the additional room elem
			container.find('.additional-room.room-' + numRooms).slideDown();

			// Remove the disabled attributes from the adults and childrens fields for this room number
			parentElem.find('#adults-' + numRooms).removeAttr('disabled');
			parentElem.find('#children-' + numRooms).removeAttr('disabled');

			if (numRooms === 2) {
				// Remove the fade out class from the remove trigger
				container.find('.js__additional-remove-rooms-trigger').removeClass('fade-out');
			}

			if (numRooms === 9) {
				// Add the fade out class from this trigger
				$(this).addClass('fade-out');
			}

			calculateOccupancy(parentElem);
		}
	});

	//Reduce num of rooms
	$('.js__additional-remove-rooms-trigger').on('click', function (e) {
		e.preventDefault();

		var parentElem = $(this).closest('.guests-container');
		var container = parentElem.find('.rooms-popup');
		var numRoomsElem = container.find('.room-counter__counter p');
		var numRooms = parseInt(numRoomsElem.html()) - 1;

		if (numRooms >= 1) {
			// Update the rooms data attribute
			parentElem.find('.js__book-num-rooms').attr('data-rooms', numRooms);

			// Update the popup rooms number indicator
			numRoomsElem.html(numRooms);

			// Hide the last room elem
			container.find('.additional-room.room-' + (numRooms + 1)).slideUp();

			// Disable the adults and childrens fields for this room number
			parentElem.find('#adults-' + (numRooms + 1)).val(0);
			parentElem.find('#adults-' + (numRooms + 1)).attr('disabled', true);

			parentElem.find('#children-' + (numRooms + 1)).val(0);
			parentElem.find('#children-' + (numRooms + 1)).attr('disabled', true);

			// Reset the select elems to default values
			$('#popup-adults-' + (numRooms + 1)).val(2);
			$('#popup-children-' + (numRooms + 1)).val(0);

			if (numRooms === 1) {
				$(this).addClass('fade-out');
			}

			if (numRooms === 8) {
				// Remove the fade out class from the add trigger
				container.find('.js__additional-add-rooms-trigger').removeClass('fade-out');
			}

			calculateOccupancy(parentElem);
		}
	});

	//Open booknig popup
	$('.js__rooms-popup-trigger').on('click', function (e) {
		e.preventDefault();

		var popup = $(this).data('popup');

		$('#' + popup).addClass('active');
	});

	//Close booking popup
	$('.js__popup-close').on('click', function (e) {
		e.preventDefault();
		$('.rooms-popup').removeClass('active');
	});


	//Update Adults/Children amount
	$('.m__check-availability .rooms-popup .popup__innner .input-container select').on(
		'change',
		function (e) {
			var parentElem = $('.m__check-availability .guests-container');
			var hiddenField = $(this).data('field');
			var value = $(this).val();

			$('.m__check-availability #' + hiddenField).val(value);
			updateOptions(e.target);

			calculateOccupancy(parentElem);
		}
	);

	function updateOptions(selectElement) {
		const roomDiv = selectElement.closest('.row');
		const isAdultSelect = selectElement.name.includes('adults');
		const selectedValue = parseInt(selectElement.value);

		let correspondingSelect;
		let maxValue = 8 - selectedValue;

		if (isAdultSelect) {
			correspondingSelect = roomDiv.querySelector('[name*="children"]');
		} else {
			correspondingSelect = roomDiv.querySelector('[name*="adults"]');
		}

		// Iterate over all options in the corresponding select box
		for (let i = 0; i < correspondingSelect.options.length; i++) {
			const option = correspondingSelect.options[i];
			if (parseInt(option.value) > maxValue) {
				option.classList.add('hidden');
			} else {
				option.classList.remove('hidden');
			}
		}

		// If the selected number of the corresponding select exceeds the new max, reset to maxValue
		if (parseInt(correspondingSelect.value) > maxValue) {
			correspondingSelect.value = maxValue;
		}
	}

	$('.reservations-overlay .rooms-popup .popup__innner .input-container select').on(
		'change',
		function (e) {
			var parentElem = $('.reservations-overlay .guests-container');
			var hiddenField = $(this).data('field');
			var value = $(this).val();

			$('.reservations-overlay #' + hiddenField).val(value);

			calculateOccupancy(parentElem);
		}
	);

    //Submit the form!
	$('.form-submit-btn').on('click', function (e) {
		e.preventDefault();

		var bookingForm = $(this).closest('form');

		var action = bookingForm.attr('action');
		var searchArray = bookingForm.serializeArray();

		var searchString = '';
		var childrenCount = 0;

		$.each(searchArray, function (key, value) {
			var excludedNames = [
				'popup-adults-1',
				'popup-adults-2',
				'popup-adults-3',
				'popup-adults-4',
				'popup-adults-5',
				'popup-adults-6',
				'popup-adults-7',
				'popup-adults-8',
				'popup-adults-9',
				'popup-children-1',
				'popup-children-2',
				'popup-children-3',
				'popup-children-4',
				'popup-children-5',
				'popup-children-6',
				'popup-children-7',
				'popup-children-8',
				'popup-children-9',
			];

			var isLastElement = key == searchArray.length - 1;

			if (!excludedNames.includes(value.name)) {
				if (value.name == 'children[]') {
					childrenCount = parseInt(value.value);
					var name = value.name.replace('[]', '%5B%5D');
					searchString += name + '=' + value.value;
					
					// Always add aoc parameter, but only add ages if there are children
					if (childrenCount > 0) {
						// Add ages immediately after children parameter
						var ages = Array(childrenCount).fill('6').join(',');
						searchString += `&aoc%5B%5D=${ages}`;
					} else {
						searchString += '&aoc%5B%5D=';
					}
					searchString += '&';
				} else if (value.name == 'adults[]') {
					var name = value.name.replace('[]', '%5B%5D');
					searchString += name + '=' + value.value + '&';
				} else {
					if (isLastElement) {
						searchString += value.name + '=' + value.value;
					} else {
						searchString += value.name + '=' + value.value + '&';
					}
				}
			}
		});

		const abTestData = getAbTestCookieData();
		let abTestString = '';

		if (abTestData) {
			if (abTestData.value === 1) {
				abTestString = `&icid=vwopph-${abTestData.campaignId}control1`;
			} else {
				const variationNumber = abTestData.value - 1;
				abTestString = `&icid=vwopph-${abTestData.campaignId}variation${variationNumber}`;
			}
		}

		var bookingUrl = `${action}${searchString}&rhgext=Qm9PSty6s3HG${abTestString}`;

		// if the gclid parameter exists, add it to the booking url
		if (sessionStorage.getItem('gclid')) {
			bookingUrl += `&gclid=${sessionStorage.getItem('gclid')}`;
		}

		window.open(bookingUrl, '_blank');
	});



	function calculateOccupancy(parentElem) {
		//Init the various vara
		var rooms = 0,
			adults = 0,
			childs = 0;

		//Loop through all possible rooms
		var i = 1,
			iTotal = parentElem.find('.js__book-num-rooms').attr('data-rooms');

		while (i <= iTotal) {
			if (parentElem.find('#popup-adults-' + i).val() > 0) {
				//This room is occupado!
				rooms++;

				adults = adults + parseInt(parentElem.find('#popup-adults-' + i).val());
				childs = childs + parseInt(parentElem.find('#popup-children-' + i).val());
			}

			i++;
		}

		//Get the labels right innit!
		var roomsLabel = 'Room',
			adultsLabel = 'Adult',
			childsLabel = 'Child';

		if (rooms > 1) {
			roomsLabel += 's';
		}

		if (adults > 1) {
			adultsLabel += 's';
		}

		if (childs > 1) {
			childsLabel = 'Children';
		}

		//Update the client facing label
		if (rooms > 0) {
			parentElem.find('#book__rooms').html(rooms + ' ' + roomsLabel);
		}

		if (adults > 0) {
			parentElem.find('#book__adults').html(adults + ' ' + adultsLabel);
		} else {
			parentElem.find('#book__adults').html('');
		}

		if (childs > 0) {
			parentElem.find('#book__children').html(childs + ' ' + childsLabel);
		} else {
			parentElem.find('#book__children').html('');
		}
	}





	// Full Width Slider
	const $fullWidthSlider = $('.full-width-slider');

	if ($fullWidthSlider.length) {
		$fullWidthSlider.slick({
			arrows: false,
			dots: true,
			autoplay: true,
			fade: true,
		});
	}

	// Set a flag to indicate the slider is initialized
    $fullWidthSlider.on('init', function(event, slick) {
        $fullWidthSlider.data('slick-initialized', true);
    });

	if ($('body').hasClass('home')) {
		const slideIndex = getSlideIndexFromURL();
		if (!isNaN(slideIndex) && slideIndex >= 0) {
			// Check if the slider is already initialized
			if ($fullWidthSlider.hasClass('slick-initialized')) {
				navigateToSlide($fullWidthSlider, slideIndex);
			} else {
				// Wait until the slider is initialized
				let initAttempts = 0;
				const maxAttempts = 50;
				const checkInterval = 100; // milliseconds

				const initializationCheck = setInterval(function() {
					if ($fullWidthSlider.data('slick-initialized') || initAttempts >= maxAttempts) {
						clearInterval(initializationCheck);
						if ($fullWidthSlider.data('slick-initialized')) {
							navigateToSlide($fullWidthSlider, slideIndex);
						}
					}
					initAttempts++;
				}, checkInterval);
			}
		}
	}

	// Go to specific slide
	function navigateToSlide(slider, index) {
		const slideCount = slider.slick('getSlick').slideCount;
		const targetIndex = index < slider.slick('getSlick').slideCount ? index : 0;
		slider.slick('slickGoTo', targetIndex, true);
	}

	// Half Width Content Slider
	if ( $('.js__half-width-content-slider').length ) {
		var arrow = '/wp-content/themes/county_hall/library/images/icons/btn-arrow.svg';

		$slick_slider = $('.js__half-width-content-slider');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: false,
			fade: true,
			nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ arrow +");'></div>",
			prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ arrow +");'></div>"
		}
		$slick_slider.slick(settings);		
	}

	//Content and Image Slider
	if ( $('.js__content-and-image-slider--images').length ) {
		var arrow = '/wp-content/themes/county_hall/library/images/icons/btn-arrow.svg';

		$slick_slider = $('.js__content-and-image-slider--images');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: false,
			fade: true,
			nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ arrow +");'></div>",
			prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ arrow +");'></div>",
			asNavFor: ".js__content-and-image-slider--content"
		}
		$slick_slider.slick(settings);		
	}
	if ( $('.js__content-and-image-slider--content').length ) {
		$slick_slider = $('.js__content-and-image-slider--content');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: false,
			swipe: false,
			fade: true
		}
		$slick_slider.slick(settings);		
	}		

	// Image Slider
	if ( $('.js__image-slider').length ) {
		var arrow = '/wp-content/themes/county_hall/library/images/icons/btn-arrow.svg';

		$slick_slider = $('.js__image-slider');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: false,
			fade: true,
			nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ arrow +");'></div>",
			prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ arrow +");'></div>"
		}
		$slick_slider.slick(settings);		
	}	

	// Grid Slider - Mobile Only
	if ( $('.js__grid-mobile-slider').length && $(window).width() < 576 ) {
		var arrow = '/wp-content/themes/county_hall/library/images/icons/arrow.svg';

		$slick_slider = $('.js__grid-mobile-slider');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: true,
			nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ arrow +");'></div>",
			prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ arrow +");'></div>"
		}
		$slick_slider.slick(settings);

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ($(window).width() >= 576) {
				if ($slick_slider.hasClass('slick-initialized')) {
					$slick_slider.slick('unslick');
				}
				return
			}

			if (!$slick_slider.hasClass('slick-initialized')) {
				return $slick_slider.slick(settings);
			}
		});		
	}	

	// Testimonials Slider	
	if ( $('.js__testimonials-slider').length ) {
		var arrow = '/wp-content/themes/county_hall/library/images/icons/btn-arrow.svg';

		$slick_slider = $('.js__testimonials-slider');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: false,
			fade: true,
			nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ arrow +");'></div>",
			prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ arrow +");'></div>",
			appendArrows: $('.js__testimonials-slider-arrows')
		}
		$slick_slider.slick(settings);		
	}	

	if ( $('.js__local-area-slider').length ) {
		var arrow = '/wp-content/themes/county_hall/library/images/icons/btn-arrow.svg';

		$slick_slider = $('.js__local-area-slider');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: false,
			fade: true,
			nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ arrow +");'></div>",
			prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ arrow +");'></div>"
		}
		$slick_slider.slick(settings);		
	}	
	$('.m__half-width-content-block .container .content-col .content-container .attraction').mouseenter(function() {
		var slideID = $(this).data('attraction-id');
		$('.js__local-area-slider').slick('slickGoTo', slideID);
	});	

	// Check Availability
	$('.more-options').on('click', function(e) {
		e.preventDefault();

		$(this).parent().parent().parent().siblings('.hidden').slideToggle();
		$(this).find('.icon').toggleClass('rotate');
	});

	// Datepicker
	$(".overlay-check-in").datepicker({ 
		minDate: 0,
		dateFormat: "dd/mm/yy",
		altField: "#overlay-check-in-date",
		altFormat: "yy-mm-dd",
	    onSelect: function(dateText, inst) {
	    	$(this).parent('.input-container').addClass('date-chosen');
	    	var checkInDate = new Date($('#overlay-check-in-date').val());
	    	var checkOutDate = new Date($('#overlay-check-out-date').val());
	    	var newCheckOutDate = new Date(checkInDate);
	    	newCheckOutDate.setDate(checkInDate.getDate() + 1);

	    	if ( checkInDate >= checkOutDate ) {
		    	$('.overlay-check-out').datepicker( "setDate", newCheckOutDate );
	    	}

		    $('.overlay-check-out').datepicker( "option", "minDate", newCheckOutDate );
	    }
	});
	$(".overlay-check-out").datepicker({ 
		minDate: 0,
		dateFormat: "dd/mm/yy",
		altField: "#overlay-check-out-date",
		altFormat: "yy-mm-dd",
	    onSelect: function(dateText, inst) {
	    	$(this).parent('.input-container').addClass('date-chosen');
	    }
	});

	$(".module-check-in").datepicker({ 
		minDate: 0,
		dateFormat: "dd/mm/yy",
		altField: "#module-check-in-date",
		altFormat: "yy-mm-dd",
	    onSelect: function(dateText, inst) {
	    	$(this).parent('.input-container').addClass('date-chosen');
	    	var checkInDate = new Date($('#module-check-in-date').val());
	    	var checkOutDate = new Date($('#module-check-out-date').val());
	    	var newCheckOutDate = new Date(checkInDate);
	    	newCheckOutDate.setDate(checkInDate.getDate() + 1);

	    	if ( checkInDate >= checkOutDate ) { 
		    	$('.module-check-out').datepicker( "setDate", newCheckOutDate );
	    	}

		    $('.module-check-out').datepicker( "option", "minDate", newCheckOutDate );
	    }
	});
	$(".module-check-out").datepicker({ 
		minDate: 0,
		dateFormat: "dd/mm/yy",
		altField: "#module-check-out-date",
		altFormat: "yy-mm-dd",
	    onSelect: function(dateText, inst) {
	    	$(this).parent('.input-container').addClass('date-chosen');
	    }
	});	

	// MatchHeight	
	$('.js__match-height').matchHeight();	
	$('.js__rooms-match-height').matchHeight();	
	$('.m__rooms-grid.grid .room-col .room .room-details').matchHeight();	
	/*$('.js__testimonial-match-height').matchHeight({
		byRow: false
	});*/

	// Local Area
	var tabContentHeight = $('.m__local-area .tab-content-row .tab-content.active').outerHeight();
	$('.m__local-area .tab-content-row').css('min-height', tabContentHeight+'px');
	
	$('.m__local-area .tab').on('click', function(e) {
		e.preventDefault();

		if ( !$(this).hasClass('active') ) {
			$('.m__local-area .tab').removeClass('active');
			$(this).addClass('active');

			var tabContent = $(this).data('tab-content');

			$('.m__local-area .tab-content-row .tab-content').fadeOut();
			$('.m__local-area .tab-content-row .tab-content#'+tabContent).fadeIn();
		}
	});

	// Gallery
	$('.grid .grid-item .overlay-container').on('click', function() {
		var slideIndex = $(this).parent().index();
		// Check if screen size is larger than 767px
		if ( $('.m__gallery .categories .category').css('text-align') == 'left' ) { // iPad and above
			var filterCount = 0;

			$('.m__gallery-grid .grid .grid-item').each(function() {
				var filteredSlideIndex = $(this).index();
			});

			// Show overlay once the slider has initialised
			$('.gallery-slider').on('init', function(event, slick){
				$(window).trigger('resize');

				$('.m__gallery-lightbox').addClass('showing');

				$('.gallery-slider').find('.slick-list').attr('tabindex', 0).focus();
			});	

			var arrow = '/wp-content/themes/county_hall/library/images/icons/btn-arrow.svg';

			$('.gallery-slider').slick({
				initialSlide: slideIndex,
				arrows: true,
				nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ arrow +");'></div>",
				prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ arrow +");'></div>",
				appendArrows: $('.gallery-slider-container'),
				dots: false,
				autoplay: false,
				adaptiveHeight: true,
				variableWidth: true
			});	
		} else { // mobile

		}
	});

	$('.m__gallery-lightbox .background, .controls .close-container .close-icon').on('click', function() {
		$('.m__gallery-lightbox').removeClass('showing');
		$('.gallery-slider').slick('unslick');
	});	

	// Galley Deckhair Link
	/*$('#webcam-link').on('click', function(e) {
		e.preventDefault();

		$('html, body').animate({
		    scrollTop: $('.m__deckchair').offset().top
		}, 1500);
	});
	$("#gallery-cat").on('click', function(e) {
		console.log('hh');
						e.preventDefault();
						$('html, body').animate({
							scrollTop: $('#gallery-id').offset().top
						}, 1500);
					});	*/

    // Map Init
    if ( $('#map').length ) {
        initMap();
    }	

    // Rooms page lightbox
    $('.js__lightbox-trigger').on('click', function(e) {
    	e.preventDefault();

    	var image = $(this).data('image');

    	$('.lightbox .image-container img').attr('src', image);
    	$('.lightbox').addClass('showing');
    });

    $('.js__close-lightbox').on('click', function(e) {
		$('.lightbox').removeClass('showing');
    });

	// Tooltips
	iconTooltipWidth();	

	// ScrollDepth
	jQuery(function() {
		jQuery.scrollDepth();
	});	



	//Custom popup Check
	if($('.custom-overlay').length > 0){
		var checkCustomPopupCookie = getCookie('pp_custom_popup');
		if(checkCustomPopupCookie){
			//Do nothing as they have the cookie
		}else{
			//Show the popup!
			$('.custom-overlay').addClass('active');

			setCookie('pp_custom_popup','popped',1);
		}
	}
	$('.custom-overlay .close-button').click(function(){
		$('.custom-overlay').removeClass('active');
	})


	//Custom code to handle the default 'read more' option within the WYSIWYG field
	//Only used on the full width content area module atm
	//Also currently a little flawed as if there's multiple of these on a single page, clicking one opens all!
	//But don't judge i'm clearing tickets 😤
	$('.js__read-more-toggle').click(function(){
		$('.js__read-more-toggle').addClass('hide');
		$('.js__read-more-content').removeClass('hide');
	})

	// MeetingsPackage Code
	if ( document.getElementById('js-meeting-package-container') ) {
		var widgetID = document.getElementById('js-meeting-package-container').getAttribute('data-widget-id');
		var locationID = document.getElementById('js-meeting-package-container').getAttribute('data-location');
		var lang = document.getElementById('js-meeting-package-container').getAttribute('data-language');

		if (typeof existingScript === 'undefined') {
			let existingScript
		}
		if (typeof existingIframe === 'undefined') {
			let existingIframe
		}
		if (typeof scriptTag === 'undefined') {
			let scriptTag
		}
		existingScript = document.getElementById("mp_snippet_script")
		if (existingScript) {
		 	existingScript.remove()
		}
		existingIframe = document.getElementById("mp-bookingengine")
		if (existingIframe) {
			existingIframe.remove()
		}

		scriptTag = document.createElement('script')
		scriptTag.setAttribute('id', 'mp_snippet_script')
		scriptTag.setAttribute('type', 'text/javascript')
		scriptTag.setAttribute('src', 'https://bookingengine-mp.s3.eu-west-2.amazonaws.com/script.js')
		scriptTag.setAttribute("async", true)
		scriptTag.setAttribute('langcode', lang);
		scriptTag.setAttribute('whitelabel_id', '288245')
		scriptTag.setAttribute('widget_id', widgetID)
		scriptTag.setAttribute('version', 'frontpage-v4')
		scriptTag.setAttribute('people', '10')
		scriptTag.setAttribute('destination', locationID);

		document.getElementById("mp-booking-engine-iframe-container").appendChild(scriptTag)

		setTimeout(() => {
		  	$('.m__meetings-package .loader').hide();
		}, 2000);
		

	}

	// Create session storage for tracking params passed in URL
	setSessionStorageForTrackingParams();

	// Add tracking hidden input fields
	addTrackingElems();
		
	// Add tracking params to radisson URLs
	addTrackingParamsToRadissonUrls();
}

function setSessionStorageForTrackingParams() {
	const paramTypes = ['facilitatorId', 'cid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
	const currentUrlParams = new URLSearchParams(window.location.search);

	paramTypes.forEach(param => {
		if (currentUrlParams.has(param)) {
			var cookieVal = currentUrlParams.get(param).replaceAll(' ', '+');

			sessionStorage.setItem(param, cookieVal);
		}
	});
}

function addTrackingElems() {
	if ( sessionStorage.facilitatorId ) {
		var inputHTML = '<input type="hidden" name="facilitatorId" id="facilitatorId" value="'+sessionStorage.facilitatorId+'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if ( sessionStorage.cid ) {
		var inputHTML = '<input type="hidden" name="cid" id="cid" value="'+sessionStorage.cid+'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if ( sessionStorage.utm_source ) {
		var inputHTML = '<input type="hidden" name="utm_source" id="utm_source" value="'+sessionStorage.utm_source+'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if ( sessionStorage.utm_medium ) {
		var inputHTML = '<input type="hidden" name="utm_medium" id="utm_medium" value="'+sessionStorage.utm_medium+'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if ( sessionStorage.utm_campaign ) {
		var inputHTML = '<input type="hidden" name="utm_campaign" id="utm_campaign" value="'+sessionStorage.utm_campaign+'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if ( sessionStorage.utm_content ) {
		var inputHTML = '<input type="hidden" name="utm_content" id="utm_content" value="'+sessionStorage.utm_content+'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if ( sessionStorage.utm_term ) {
		var inputHTML = '<input type="hidden" name="utm_term" id="utm_term" value="'+sessionStorage.utm_term+'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
}

function addTrackingParamsToRadissonUrls() {
	const paramTypes = ['facilitatorId', 'cid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
	const currentUrlParams = new URLSearchParams(window.location.search);
	const radissonLinksNodeList = document.querySelectorAll('a[href*="radissonhotels.com"]');
	const radissonLinks = [...radissonLinksNodeList];
	
	radissonLinks.forEach(link => {
		let href = link.getAttribute('href');
		
		paramTypes.forEach(param => {
			if (! href.includes(param)) {
				let paramVal = false;
				if (currentUrlParams.has(param)) { // Check for param in query string
					paramVal = currentUrlParams.get(param);
				} else if (getCookie(param)) { // Check for param in cookies
					paramVal = getCookie(param);
				}

				if (paramVal && paramVal > '') {
					href = addParamToUrl(href, param, paramVal);
					link.setAttribute('href', href);
				}
			}
		})
	})
}

function addParamToUrl(url, param, value) {
	if (url.includes('?')) {
		const lastChar = url.charAt(url.length - 1);
		if (lastChar === '/') {
			const urlWithoutTrailingSlash = url.slice(0,-1);
			return `${urlWithoutTrailingSlash}&${param}=${value}`;
		}
		return `${url}&${param}=${value}`;
	}

	return `${url}?${param}=${value}`;
}


function setCookie(name,value,days) {
  var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }
  function eraseCookie(name) {
      document.cookie = name+'=; Max-Age=-99999999;';
  }







function ZoomControl(controlDiv, map) {
	google.maps.event.addDomListener(zoomout, 'click', function() {
		var currentZoomLevel = map.getZoom();
		if (currentZoomLevel != 0) {
			map.setZoom(currentZoomLevel - 1);
		}     
	});

	google.maps.event.addDomListener(zoomin, 'click', function() {
		var currentZoomLevel = map.getZoom();
		if(currentZoomLevel != 21){
			map.setZoom(currentZoomLevel + 1);
		}
	});
}

function initMap() {
	var mapLat = $('#map').data('lat');
	var mapLng = $('#map').data('lng');
	var location = {lat: mapLat, lng: mapLng};

	var map = new google.maps.Map(document.getElementById('map'), {
		zoom: 15,
		center: location,
		mapTypeControl: false,
		fullscreenControl: false,
		streetViewControl: false,
		zoomControl: false		
	});

	//imageURL = '/wp-content/themes/county_hall/library/images/icons/marker.png';

	// var image = {
	// 	url: imageURL,
	// 	scaledSize: new google.maps.Size(97, 138),
	// 	origin: new google.maps.Point(0, 0),
	// 	anchor: new google.maps.Point(0, 138)
	// };	

	var marker = new google.maps.Marker({
		position: location,
		map: map,
		icon: '/wp-content/themes/county_hall/library/images/icons/marker.png',
	});

	/* Create the DIV to hold the control and call the ZoomControl() constructor passing in this DIV. */
	var customZoomDiv = document.createElement('div');
	var customZoom = new ZoomControl(customZoomDiv, map);	
}	

function iconTooltipWidth() {
	var tooltip = $('.icon-tooltip');

	tooltip.each(function() {
		var tooltipText = $(this).text();
		var tooltipLength = tooltipText.length;
		var width = 10 * tooltipLength;

		$(this).css('width', width+'px');
	});
}

function getAbTestCookieData() {
	const cookies = document.cookie.split(';');
	let returnData = false;

	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim();

		// Check if the cookie starts with the expected prefix
		if (cookie.indexOf('_vis_opt_exp_') === 0) {
			const [initial, prefix, opt, exp, campaignId, suffix] = cookie.split('_');

			// Check if the cookie structure matches
			if (suffix.indexOf('combi=') === 0) {
				const [name, value] = suffix.split('=');

				return {
					name: name,
					value: parseInt(value),
					campaignId: parseInt(campaignId),
				};
			}
		}
	}

	return false;
}

// Get slide Param from URL
function getSlideIndexFromURL() {
	const urlParams = new URLSearchParams(window.location.search);
	const slideIndex = urlParams.get('slide');
	return slideIndex ? parseInt(slideIndex) - 1 : 0; // Convert to zero-based index
}

function appendLinksWithGclid() {
	const links = document.querySelectorAll('a');

	if ( links ) {		
		const domain = igniteJsVars.domain;
	
		links.forEach((link) => {
			if (link.href.includes(domain) && !link.href.includes('gclid') && link.getAttribute('target') == '_blank') {
				addGclidToLink(link);
			}
		});
	}
}

function appendRadissonLinksWithGclid() {
	const links = document.querySelectorAll('a[href*="radissonhotels.com"]');

	if ( links ) {
		links.forEach((link) => {
			addGclidToLink(link);
		});
	}
}

function addGclidToLink(link) {
	// Get all url parameters for this link
	const urlParams = new URLSearchParams(link.href.split('?')[1]);
					
	// Get the gclid from sessionStorage
	const gclid = sessionStorage.getItem('gclid');

	if (gclid) {
		// If the link already has parameters, add gclid with & else add gclid with ?
		link.href += urlParams.toString() ? `&gclid=${gclid}` : `?gclid=${gclid}`;
	}
}

function getGclidParameter() {
	const urlParams = new URLSearchParams(window.location.search);
	const gclid = urlParams.get('gclid');

	// If the gclid parameter exists, add it to the session storage
	if (gclid) {
		sessionStorage.setItem('gclid', gclid);
	}
}